import { render, staticRenderFns } from "./TopMenorFaturamentoCard.vue?vue&type=template&id=9407bd44"
import script from "./TopMenorFaturamentoCard.vue?vue&type=script&lang=js"
export * from "./TopMenorFaturamentoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports